import React, { Component } from "react";
import styled from "styled-components";
import { Button, NonIdealState, Spinner, Toaster, Position } from "@blueprintjs/core";
import Editor from "../components/Editor";
import { withFirebase } from "../components/Firebase";
import { withAuthentication } from "../components/Session";
import Viewer from "../components/Viewer";
import { RouteComponentProps, Redirect } from "react-router";
import ScriptEditor from "../components/ScriptEditor/ScriptEditor";

const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface PathParams {
  id: string;
}

interface Props extends RouteComponentProps<PathParams> {
  firebase: any;
  authUser: any;
}

class Script extends Component<Props> {
  state = {
    document: null,
    notFound: false,
    id: this.props.match.params.id,
    deleted: false
  };

  // toast = React.createRef();

  componentDidMount() {
    const id = this.state.id;
    // Dont try to fetch the design if we're making a new one
    if (id === "new") return;

    this.props.firebase.db
      .collection("scripts")
      .doc(id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.setState({ document: doc.data() });
        } else {
          // doc.data() will be undefined in this case
          this.setState({ notFound: true });
        }
      })
      .catch(error => {
        console.log("Error getting document:", error);
      });
  }

  handleSave = (code, data, title) => {
    const id = this.state.id;
    if (id === "new") {
      this.props.firebase.db
        .collection("scripts")
        .add({
          data,
          title,
          code,
          user: this.props.authUser.uid
        })
        .then(docRef => {
          // this.toast.show({
          //   message: "Saved script",
          //   intent: "success",
          //   icon: "cloud-upload"
          // });
          this.setState({ id: docRef.id });
          history.pushState({}, null, `/scripts/${docRef.id}`);
        });
    } else {
      this.props.firebase.db
        .collection("scripts")
        .doc(id)
        .update({
          data,
          title,
          code
        })
        .then(() => {
          // this.toast.show({
          //   message: "Saved script",
          //   intent: "success",
          //   icon: "cloud-upload"
          // });
        });
    }
  };

  handleDelete = () => {
    this.props.firebase.db
      .collection("scripts")
      .doc(this.state.id)
      .delete()
      .then(() => this.setState({ deleted: true }));
  };

  pushToLive = (script, type) => {
    this.props.firebase.db
      .collection("panels")
      .doc("1")
      .update({
        script,
        type
      });
  };

  render() {
    const newDesign = this.props.match.params.id === "new";

    if (this.state.deleted === true) return <Redirect to="/scripts" />;

    if (newDesign && !this.props.authUser) {
      return (
        <NonIdealState
          icon="lock"
          title="Sign up to start designing"
          description="To start creating your own designs you need to sign up for a vette.website account. If you already have an account, please log in."
        />
      );
    }
    return (
      <>
        {/* <Toaster position={Position.TOP} ref={this.toast} /> */}
        {(() => {
          if (newDesign && this.props.authUser) {
            return (
              <ScriptEditor
                disabled={false}
                document={null}
                handleSave={this.handleSave}
                pushToLive={this.pushToLive}
              />
            );
          }

          // Found document owned by current user
          if (
            this.state.document !== null &&
            this.props.authUser &&
            this.state.document.user === this.props.authUser.uid
          ) {
            return (
              <ScriptEditor
                disabled={false}
                document={this.state.document}
                handleSave={this.handleSave}
                pushToLive={this.pushToLive}
                handleDelete={this.handleDelete}
              />
            );
          }

          // Found document
          if (this.state.document !== null) {
            return (
              <ScriptEditor
                disabled={true}
                document={this.state.document}
                pushToLive={this.pushToLive}
              />
            );
          }

          // Could not find document
          if (this.state.notFound === true) {
            return (
              <NonIdealState
                icon="search"
                title="Not found"
                description="This design could not be found. It may have been deleted or the ID is incorrect."
              />
            );
          }

          // Loading
          return (
            <Center>
              <Spinner />
            </Center>
          );
        })()}
      </>
    );
  }
}

export default withAuthentication(withFirebase(Script));
